/* ============================================================
   ADEZIV ALB MUREXIN KWF 60 — bag calculator.
   Standalone & self-contained; reuses the .tvn-* markup of the hero.
   Suprafață (m²) × consum (kg/m²) → kg → saci de N kg (+10% rezervă).
   Sets #tvn-qty (number of bags) on "Folosește această cantitate".
   Idempotent; re-runs on shopify:section:load (Theme Editor).
   ============================================================ */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function ron(value) {
    var r = Math.round(value * 100) / 100;
    var hasDec = Math.abs(r - Math.round(r)) > 0.001;
    return r.toLocaleString('hu-HU', { minimumFractionDigits: hasDec ? 2 : 0, maximumFractionDigits: 2 }) + ' HUF';
  }
  function roNum(value) {
    return (Math.round(value * 10) / 10).toLocaleString('hu-HU');
  }

  function init(root) {
    root = root || document;
    $$('[data-adz-calc]', root).forEach(function (calc) {
      if (calc.dataset.adzInit === '1') return;
      calc.dataset.adzInit = '1';
      var area = $('#adz-area', calc), consum = $('#adz-consum', calc), waste = $('#adz-waste', calc);
      var outKg = $('#adz-kg', calc), outBags = $('#adz-bags', calc), outTotal = $('#adz-total', calc);
      var useBtn = $('[data-adz-calc-use]', calc);
      var priceCents = parseFloat(calc.getAttribute('data-price-cents')) || 0;
      var bagKg = parseFloat(calc.getAttribute('data-bag-kg')) || 25;
      var pricePerBag = priceCents / 100;

      function compute() {
        var a = parseFloat(area && area.value) || 0;
        var cov = parseFloat(consum && consum.value) || 0; // m² acoperiți de un sac
        var areaAdj = a;
        if (waste && waste.checked) areaAdj *= 1.10;
        var bags = (cov > 0 && areaAdj > 0) ? Math.ceil(areaAdj / cov - 1e-9) : 0;
        var kg = bags * bagKg;
        if (outKg) outKg.textContent = roNum(kg) + ' kg';
        if (outBags) outBags.textContent = bags + (bags === 1 ? ' zsák' : ' zsák');
        if (outTotal) outTotal.textContent = bags > 0 ? ron(bags * pricePerBag) : '0 HUF';
        calc._bags = bags;
      }
      [area, consum].forEach(function (el) { if (el) el.addEventListener('input', compute); });
      if (waste) waste.addEventListener('change', compute);
      if (useBtn) useBtn.addEventListener('click', function () {
        var qty = Math.max(1, calc._bags || 1);
        var target = $('#tvn-qty');
        if (target) { target.value = qty; target.dispatchEvent(new Event('change', { bubbles: true })); }
        var bb = $('#tvn-buybox'); if (bb) bb.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      compute();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else { init(document); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
